import { WithdrawalsResetLimitsProcessedItemsReducer } from './types';

export const withdrawalsResetLimitsProcessedItemsReducer: WithdrawalsResetLimitsProcessedItemsReducer =
  (state) => {
    return {
      ...state,
      withdrawalsLimitsProcessedItems: {
        ...(state.withdrawalsLimits?.items ?? undefined),
      },
    };
  };
